<template>
  <vxe-table ref="table" :data="data" :loading="loading">
    <vxe-column fixed="left" type="seq" width="40"/>
    <vxe-column field="dispatch.wave" title="business.label.wave" width="100"/>
    <vxe-column field="ordersCount" title="business.label.ordersCount" />
  </vxe-table>
</template>

<script>
import api from '@/api'
import { findAll, post } from '@/api/Api'

export default {
    name: 'UnreviewedTable',
    data() {
      return {
        loading: false,
        data: []
      }
    },
  activated() {
      this.getData()
    },
    methods: {
      getData() {
        this.loading = true
        findAll('dispatchWaveUnreviewedFactory').then(res => {
          if (res.success) {
            this.contentSize = res.contentSize
            this.data = res.result
          }
          this.loading = false
        })
      },
      review() {
        let selectedRow = this.$refs.table.getCurrentRecord()
        if (selectedRow == null) {
          this.$warning({ title: '请选择波次后再复核', centered: true })
        }
        this.loading = true
        post(api.containerReviewAll, {}, { 'wave': selectedRow.dispatch.wave }).then(res => {
          if (res.success) {
            this.$message.success('复核成功')
            this.getData()
          }
        }).finally(() => this.loading = false)
      }
    }
  }
</script>